module.exports = __webpack_public_path__ + "static/BrandonGrotesque-BoldItalic-392e3e676476fea63a049dc1b4416cd5.woff2";